function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{clip-path:url(#a);}.c{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M29.788,46.023a9.4,9.4,0,0,1,2.895-6.79H18.7v20.4H39.221V55.456A9.433,9.433,0,0,1,29.788,46.023Z",
  transform: "translate(-18.698 -39.233)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-236 4.28)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(236 -1.419)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  className: "b"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 17.791,
  height: 1.859,
  rx: 0.929,
  transform: "translate(1.483 2.639)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 17.791,
  height: 1.859,
  rx: 0.929,
  transform: "translate(1.483 7.634)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 17.791,
  height: 1.859,
  rx: 0.929,
  transform: "translate(1.483 12.628)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 17.791,
  height: 1.859,
  rx: 0.929,
  transform: "translate(1.483 17.622)"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(246.796 -4.28)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M52.541,52.246A9.146,9.146,0,1,1,61.688,43.1,9.147,9.147,0,0,1,52.541,52.246Zm0-1.016a8.13,8.13,0,1,0-8.13-8.13A8.13,8.13,0,0,0,52.541,51.229Zm-1.016-8.343a1.016,1.016,0,0,1,2.032,0v4.084a1.016,1.016,0,0,1-2.032,0Zm1.016-2.836a1.016,1.016,0,1,0-1.016-1.016A1.017,1.017,0,0,0,52.541,40.051Z",
  transform: "translate(-42.939 -33.497)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M52,52.156a9.6,9.6,0,1,1,9.6-9.6A9.613,9.613,0,0,1,52,52.156Zm0-18.292a8.691,8.691,0,1,0,8.691,8.691A8.7,8.7,0,0,0,52,33.864Zm0,17.276a8.586,8.586,0,1,1,8.586-8.586A8.6,8.6,0,0,1,52,51.141Zm0-16.26a7.674,7.674,0,1,0,7.674,7.674A7.683,7.683,0,0,0,52,34.881Zm0,13.008a1.469,1.469,0,0,1-1.472-1.462V42.342a1.472,1.472,0,0,1,2.944,0v4.084A1.469,1.469,0,0,1,52,47.889Zm0-6.1a.557.557,0,0,0-.561.551v4.084a.563.563,0,0,0,.561.551.557.557,0,0,0,.561-.551V42.342A.563.563,0,0,0,52,41.791Zm0-1.829a1.472,1.472,0,1,1,1.472-1.472A1.473,1.473,0,0,1,52,39.962Zm0-2.033a.561.561,0,1,0,.561.561A.561.561,0,0,0,52,37.929Z",
  transform: "translate(-42.395 -32.953)"
}))));

var SvgTabbarIconInformation = function SvgTabbarIconInformation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23.26,
    viewBox: "0 0 30 23.26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTabbarIconInformation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tabbar_icon_information.229421e7.svg";
export { ForwardRef as ReactComponent };